import { Button } from '@/components/ui/button'
import { PlusIcon } from 'lucide-react'
import { GenerateDocumentDialog } from '../documents-page/GenerateDocumentDialog'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useIdTokenAndTenantId } from '@/hooks/useIdTokenAndTenantId'
import {
  orgPermissionsCurrentUserOptions,
  tenantProjectsOptions,
} from '@/data/queryOptions'
import { getProjectRoles } from '@/data/entities'
import { useMemo } from 'react'
import { useRouteContext } from '@tanstack/react-router'

export function PlusButtonMobile() {
  const { idToken, TENANT_ID } = useIdTokenAndTenantId()
  const { isOrgAdmin, isOrgEditor } = useRouteContext({
    from: '/_authenticated',
  })
  const { data: projects } = useSuspenseQuery(
    tenantProjectsOptions(TENANT_ID!, idToken!),
  )
  const { data: orgPermissions } = useSuspenseQuery(
    orgPermissionsCurrentUserOptions(TENANT_ID!, idToken!),
  )
  const projectRoles = useMemo(
    () => getProjectRoles(orgPermissions, TENANT_ID!),
    [orgPermissions, TENANT_ID],
  )
  const editableProjects = useMemo(() => {
    if (isOrgAdmin || isOrgEditor) return projects ?? []
    return (projects ?? []).filter((p) => {
      const role = projectRoles.get(p.id)?.toUpperCase()
      return role === 'ADMIN' || role === 'EDITOR'
    })
  }, [projects, isOrgAdmin, isOrgEditor, projectRoles])

  return (
    <GenerateDocumentDialog
      currentProjectId={null}
      projects={editableProjects}
      canCreateWorkspace={isOrgAdmin || isOrgEditor}
    >
      <Button
        size="icon"
        className="fixed right-4 bottom-24 size-14 rounded-full shadow-lg"
      >
        <PlusIcon />
      </Button>
    </GenerateDocumentDialog>
  )
}
